import React, { Component } from 'react'
import { renderInterestTracks } from './fpgViewHelpers';
import { Link } from 'react-router-dom';
//moment import
import moment from "moment";
import FpgDisableIcon from '../../../icons/fpgdisableicon';
import FpgpublishIcon from '../../../icons/fpgpublishicon';
import FpgDeleteIcon from '../../../icons/fpgdeleteicon';
import FpgeeditIcon from '../../../icons/fpgediticon';
import PlusIcon from '../../../icons/plusicon';
import Slider from "react-slick";
import ShowPassIcon from '../../../icons/ShowPassIcon';
import ViewIcon from '../../../icons/viewIcon';
import service from "../../../../src/services";
import PopUpCustomAll from "../create/popUpCustomAll";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import ErrorPopUp from '../../errorPopUp';
import Loader from '../../loader';
import { SHORT_FILM_AVAILIBILITY, resolveFromInitial } from "../../../cosntants";
import RecordPresenceBanner from "../../RecordPresenceBanner";
let sub;

const mapStateToProps = (state) => ({
  shortProgramId: state.shortProgramId,
  profileName: state.profileName,
  currentShortTab: state.currentShortTab,
  recordViewers: state.recordViewers,
  recordConflict: state.recordConflict,
  getLoginAdminByID: state.getLoginAdminByID,
  allInitial: state.allInitial
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class ProgramView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      runTime: '',
      Hours: '7',
      Mins: '30',
      Stamps: 'AM',
      access: ["ALL", "US"],
      selectshort: false,
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false,
      getLastUpdated: '',
      images: [],
      shortDescription: '',
      longDescription: '',
      dateTime: [],
      ShortProgramList: {
        shortProgrammeFilms: []
      },
      waitList_show:false,
      data:[
        {
            label:'Short Program',
            content:''
        },
        {
            label:'Episodic Pilot Showcase',
            content:''
        }],
        activetab: this.props.currentShortTab || 0,
        film:{}
    }
    this.apiserve = new service();
    this._hasLeftPresence = false;
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
    if (this.props.shortProgramId && !this._hasLeftPresence) {
      this._hasLeftPresence = true;
      this.apiserve.sendevent("RecordPresence|leave", {
        modelName: "shortProgramme",
        recordId: this.props.shortProgramId
      });
    }
    if (this._handleBeforeUnload) {
      window.removeEventListener('beforeunload', this._handleBeforeUnload);
    }
    this.props.ClearRecordPresence();
  };

  componentDidMount = () => {
    this.props.ClearRecordPresence();
    if (this.props.allInitial) {
      this.setInitialDataFromProps(this.props.allInitial);
    }
    this.getShortProgramDetails();
    this.apiserve.sendevent("film|getLastUpdated", { type: 14 });

    // RecordPresence: Join if recordId exists
    if (this.props.shortProgramId) {
      this.apiserve.sendevent("RecordPresence|join", {
        modelName: "shortProgramme",
        recordId: this.props.shortProgramId
      });
      // Add beforeunload handler
      this._handleBeforeUnload = () => {
        if (!this._hasLeftPresence) {
          this._hasLeftPresence = true;
          this.apiserve.sendevent("RecordPresence|leave", {
            modelName: "shortProgramme",
            recordId: this.props.shortProgramId
          });
        }
      };
      window.addEventListener('beforeunload', this._handleBeforeUnload);
    }

    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "fpg|shortProgramme|getAllDetail":
          if (!response.error) {
            const data = response.data;
            const allInitial = this.props.allInitial;
            const resolvedGenre = resolveFromInitial(allInitial, 'shortProgramme', 'genre', (data.genre || []).map(item => item._id || item));
            const resolvedInterestTrack = resolveFromInitial(allInitial, 'shortProgramme', 'interestTrack', (data.interestTrack || []).map(item => item._id || item));
            const resolvedAccess = resolveFromInitial(allInitial, 'shortProgramme', 'access', data.access ? (data.access._id || data.access) : null);
            const resolvedDateTime = (data.dateTime || []).map(dt => ({
              ...dt,
              locations: resolveFromInitial(allInitial, 'shortProgramme', 'locations', dt.locations || []),
              accessibility: resolveFromInitial(allInitial, 'shortProgramme', 'accessibility', dt.accessibility || [], 'eventiveId'),
              locationCity: resolveFromInitial(allInitial, 'shortProgramme', 'city', dt.locationCity),
              interestTrack: resolveFromInitial(allInitial, 'shortProgramme', 'interestTrack', dt.interestTrack || [], 'eventiveId'),
            }));
            let shortProgrammeFilmsData = data.shortProgrammeFilms.map(item => {
              item.film.isUnavailable = (data.shortFilms && data.shortFilms.length > 0) ? data.shortFilms.filter(film => film.filmId === item.film._id)[0]?.isUnavailable : false
              return item
            })
            const resolvedShortProgramList = {
              ...data,
              shortProgrammeFilms: shortProgrammeFilmsData,
              access: resolvedAccess ? resolvedAccess : data.access,
            };
            this.setState({
              runTime: data.runTime,
              ShortProgramList: resolvedShortProgramList,
              shortData: new Date(data.date),
              loaderFlag: false,
              totalAllow: data.screening ? data.screening.totalAllow : 0,
              total: data.screening && data.screening.totalAllow && data.screening.totalAllow.inPerson,
              consumed: data.screening && data.screening.consumed ? data.screening && data.screening.consumed : 0,
              opted: data.screening && data.screening.opted ? data.screening && data.screening.opted : 0,
              lastUpdatedBy: data.screening && data.screening && data.screening.lastUpdatedBy,
              lastUpdatedAt: data.screening && data.screening && data.screening.lastUpdatedAt,
              images: data.images,
              shortDescription: data.shortDescription,
              longDescription: data.longDescription,
              screenDetails: data.screening && data.screening.screenDetails,
              dateTime: resolvedDateTime,
              online_held: data.screening && data.screening.totalHeld && data.screening.totalHeld.consumed,
              total_held: data.screening && data.screening.totalHeld && data.screening.totalHeld.allowed,
              genre: resolvedGenre.length > 0 ? resolvedGenre : (data.genre || []),
              interestTrack: resolvedInterestTrack.length > 0 ? resolvedInterestTrack : (data.interestTrack || []),
            })
          }
          break;
        case "fpg|shortProgramme|remove":
          if (!response.error) {
            this.props.history.push('/short-program-list')
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "fpg|shortProgramme|updateStatus":
          if (!response.error) {
            this.setState({
              publishFilm: false,
              disableFilm: false,
              showFromLiveFilm: false,
              hideFromLiveFilm: false,
            })
            this.apiserve.sendevent("fpg|shortProgramme|getAllDetail", { shortProgrammeId: this.props.shortProgramId });
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "film|getLastUpdated":
          this.setState({
            getLastUpdated: response.data
          })
          break;
        case "fpg|screening|update":
          if (!response.error) {
            this.getShortProgramDetails();
            this.setState({
              loaderFlag: false
            })
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "RecordPresence|join":
          if (!response.error && response?.data?.recordUpdatedAt) {
            // View mode — no editStartVersion needed
          }
          break;
        case "RecordPresence|viewersUpdate":
          if (response?.data?.recordId === this.props.shortProgramId) {
            const currentUserId = this.props.getLoginAdminByID;
            const viewers = response?.data?.viewers || [];
            const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
            const currentUserHasMultipleSessions = currentUserSessionCount > 1;
            const seenIds = new Set();
            const filteredViewers = viewers
              .filter(v => {
                if (v?.userId === currentUserId) {
                  return currentUserHasMultipleSessions;
                }
                return true;
              })
              .filter(v => {
                if (seenIds.has(v?.userId)) return false;
                seenIds.add(v?.userId);
                return true;
              })
              .map(v => ({
                userId: v?.userId,
                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
              }));
            this.props.SetRecordViewers(filteredViewers);
          }
          break;
        default:
          break;
      }
    });
    setTimeout(() => {
      this.state.screenDetails && this.state.screenDetails.map((item) => {
        this.state.dateTime.map(date => {
          if (item._id === date._id) {
            item.location = date.locations.length > 0 ? date.locations[0]._id : ''
          }
          if(date.locations.length > 0) {
            this.setState({
              waitList_show:true 
            })
          }
        })
      })
    }, 500)
    this.setState({})
  };



  componentDidUpdate(prevProps) {
    if (prevProps.allInitial !== this.props.allInitial) {
      this.setInitialDataFromProps(this.props.allInitial);
    }
  }

  setInitialDataFromProps = (allInitial) => {
    if (allInitial && allInitial.film) {
      this.setState({
        film: allInitial.film
      });
    }
  }

  getShortProgramDetails = () => {
    this.setState({
      loaderFlag: true
    })
    var data = {
      shortProgrammeId: this.props.shortProgramId
    }

    this.apiserve.sendevent("fpg|shortProgramme|getAllDetail", data);
  };

  editShortProgramList = () => {
    this.props.history.push({
      pathname: "/program",
    });
  };

  deleteFilm = () => {
    this.setState({
      deleteFilm: true
    })
  }

  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("fpg|shortProgramme|remove", {
      shortProgrammeId: this.props.shortProgramId
    });
  }

  publishFilm = () => {
    this.setState({
      publishFilm: true
    })
  }

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("fpg|shortProgramme|updateStatus", {
      shortProgrammeId: this.props.shortProgramId,
      hideFromLive:this.state.ShortProgramList.hideFromLive,
      status: 1
    });
  }

  disableFilm = () => {
    this.setState({
      disableFilm: true
    })
  }

  disableFilmPopupYes = () => {
    this.apiserve.sendevent("fpg|shortProgramme|updateStatus", {
      shortProgrammeId: this.props.shortProgramId,
      hideFromLive:this.state.ShortProgramList.hideFromLive,
      status: 2
    });
  }

  hideFromLiveFilm = () => {
    this.setState({
      hideFromLiveFilm: true
    })
  }

  hideFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("fpg|shortProgramme|updateStatus", {
      shortProgrammeId: this.props.shortProgramId,
      status:this.state.ShortProgramList.status,
      hideFromLive: true
    });
  }

  showFromLiveFilm = () => {
    this.setState({
      showFromLiveFilm: true
    })
  }

  showFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("fpg|shortProgramme|updateStatus", {
      shortProgrammeId: this.props.shortProgramId,
      status:this.state.ShortProgramList.status,
      hideFromLive: false
    });
  }

  clearAllForm = () => {
    this.setState({
      name: "",
      access: "",
      date: new Date(),
      hours: '7',
      minutes: "30",
      state: "AM",
      shortProgrammeFilms: [],
    })
    this.props.ShortProgramEditData('')
    this.props.history.push('/program')
  }

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false,
    });
  };

  handleChange = (e, id) => {
    const { name, value } = e.target
    if (name === 'premierTicketsAllowed' || name === 'premierTicketsWaitList' || name === 'publicPassHolderAllowed' || name === 'industryReservationAllowed' || name === 'holdSceeringAvailableAllowed' || name === 'total' || name === 'online') {
      this.state.screenDetails.map((item) => {
        if (item._id === id && /^[0-9]*$/.test(e.target.value)) {
          item.singleTicket.allowed = name === "premierTicketsAllowed" ? value : item.singleTicket.allowed
          item.singleTicket.waitList = name === 'premierTicketsWaitList' ? value : item.singleTicket.waitList
          item.publicPackageTicket.allowed = name === 'publicPassHolderAllowed' ? value : item.publicPackageTicket.allowed
          item.piPackageTicket.allowed = name === 'industryReservationAllowed' ? value : item.piPackageTicket.allowed
          item.holdTickets.allowed = name === 'holdSceeringAvailableAllowed' ? value : item.holdTickets.allowed
        }
        if ((name === 'total' || name === 'online') && /^[0-9]*$/.test(e.target.value)) {
          this.setState({
            [name]: value
          })
        }
        this.state.dateTime.map(l => {
          if (l._id === item._id) {
            item.location = l.locations.length > 0 ? l.locations[0]._id : ''
          }
        })
      })
      this.setState({})
    } else {
      this.setState({
        [name]: value
      })
    }
  }

  screnningUpdated = () => {
    this.setState({
      loaderFlag: true
    })
    var data = {
      filmId: this.props.shortProgramId,
      filmType: 'ShortProgramme',
      total: this.state.total,
      consumed: this.state.consumed,
      opted: this.state.opted,
      totalAllow: {
        inPerson: this.state.total,
        online: 0
      },
      screenDetails: this.state.screenDetails,
    };
    this.apiserve.sendevent("fpg|screening|update", data);
  }

  refreshScreening = (e) => {
    this.setState({
      loaderFlag: true
    })
    var data = {
      shortProgrammeId: this.props.shortProgramId
    }
    this.apiserve.sendevent("fpg|shortProgramme|getAllDetail", data);
  }
  getDisplayValue = (accNo) => {
    const { profileName } = this.props;
    let accessValue = profileName.CMA.find(_ => _.access === accNo);
    return accessValue ? accessValue.value : false;
  }

  backClick = () => {
    this.props.CurrentShortTab(0)
    this.props.history.push('/short-program-list')
  }

  TabClick = index => {
    this.setState({
      activetab: index
    }, () => {
      this.props.CurrentShortTab(index)
      this.props.history.push('/short-program-list')
    });
  }

  getScreeningName = (item) => {
    if(this.state.film !== undefined) {
      let screeningName = this.state.film.screnningTypeList && this.state.film.screnningTypeList.find(_ => _.type === item.screeningType && item?.locationType == _.locationType);
      return screeningName ? screeningName.name : 'N/A';
    }
  }

  render() {
    const { ShortProgramList, getLastUpdated } = this.state
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt)
    var hour = moment(updateAt).format('h')
    var minutes = moment(updateAt).format('mm')
    var state = moment(updateAt).format('A')
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy

    const { } = this.state
    var settings = {
      customPaging: function (i) {
        return (
          <a>{i + 1}</a>
        );
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <React.Fragment>
        <div className="right_side_wrapper relative">
          <ul className="fpg_admin_tab disp_flex">
              {
                  this.state.data && this.state.data.map((list,index) => {
                          return(
                              <li className={this.state.activetab === index ? 'active' : '' }>
                                  <p>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => this.TabClick(index)}>
                                      <div style={{ paddingRight: '10px',position:'relative' }}>{list.label}</div>
                                    </div>
                                      <span id= {index} onClick={(e)=>this.clearAllForm(e)}><PlusIcon /></span>
                                  </p>
                              </li>
                          )
                  })
              }
          </ul>
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <Link className="back_link" onClick={() => this.backClick()}> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List</Link>
            {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
              <p className="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname} </p>
            }
          </div>
          <RecordPresenceBanner activeViewers={this.props.recordViewers || []} conflict={null} />
          <div className="fpg_tabcontent">
            <div className="program_main d_flex">
              <div className="program_left">
                <div className="program_title_input d_flex d_flex_justify_spacebt mb_10 d_flex_align_center">
                  <h3>{ShortProgramList && ShortProgramList.name}</h3>
                  <span className="id_text"><label>Access: </label> {ShortProgramList && ShortProgramList.access && ShortProgramList.access.name}</span>
                </div>
                <div className="short_program_img">
                  <Slider {...settings} >
                    {this.state.images?.map((item, i) => {
                      return (

                        <div key={i}>
                          <div className="media_image mb_0 absolute_loader">
                            <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : '/images/image-placeholder.png'} alt="image" />
                          </div>
                        </div>
                      )
                    })}
                  </Slider>
                </div>
                <div class="relative  static_pagination"></div>
                <div className="program_header d_flex">
                  <h3>Shorts Included in Program</h3>
                </div>

                <div className="program_inner">
                  <ul>
                    {ShortProgramList && ShortProgramList?.shortProgrammeFilms?.map((item) => {
                      return (
                        <li>
                          <div className="d_flex list_inner d_flex_align_center">

                            <div className="program_contents d_flex">
                              <div className="program_image">
                                <img src={
                                  item && item.film && item.film.images && item.film.images.inSite ? this.apiserve.imageUrl + item.film.images.inSite :
                                    item && item.film && item.film.images && item.film.images.link ? item && item.film && item.film.images && item.film.images.link :
                                      '/images/image-placeholder.png'} />
                              </div>
                              <div className="program_contents_desc">
                                <h2 className="program_title">{item && item.film && item.film.title}</h2>
                                <p className="program_time">{item && item.film && item.film.runTime} min</p>
                                <p className="program_desc">{item && item.film && SHORT_FILM_AVAILIBILITY.filter(_ => item.film.isUnavailable === _.value)[0].label}</p>
                              </div>
                            </div>
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
              <div className="program_right feature_col" style={{maxWidth:`calc(100% - 610px)`}}>
                <div className="fpg_edits_links d_flex d_flex_align_center">
                  <Link className="d_flex d_flex_align_center d_flex_justify_center"
                    onClick={this.editShortProgramList}
                  >
                    <FpgeeditIcon />
                    EDIT
                  </Link>
                  {ShortProgramList && ShortProgramList.status === 1 ?
                    <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.disableFilm()}>
                      <FpgDisableIcon /> DISABLE
                    </Link>
                    :
                    <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishFilm()}>
                      <FpgpublishIcon /> PUBLISH
                    </Link>
                  }
                  {ShortProgramList && ShortProgramList.hideFromLive === true ?
                    <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.hideFromLiveFilm()}>
                      <ViewIcon /> Show On Live
                      </Link>
                    :
                    <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.showFromLiveFilm()}>
                      <ShowPassIcon /> Hide From Live
                      </Link>
                  }
                  <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteFilm()}>
                    <FpgDeleteIcon />
                    DELETE
                  </Link>
                </div>
                <div className="mt_25" style={{maxWidth:'900px'}}>
                  <div className="screen_dates">
                    <table>
                      <thead>
                        <tr>
                          <th>Event Start Date & Time (MT) - Event End Date & Time (MT)</th>
                          <th>Screening Type</th>
                          <th>Location</th>
                          <th>Waitlist Slots</th>
                          <th>Accessibility</th>
                          <th>Interest Tracks</th>
                          <th>Supress Voting</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.dateTime?.map((item) => {
                            var fpgFlimViewStart = new Date(item.date);
                            var fpgFlimViewEnd = new Date(item.endDate);
                            return (
                              <tr>
                                <td className="time_text time_text_nf">
                                  {moment(fpgFlimViewStart).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewStart).tz("US/Mountain").format('h:mm A')}  -  {moment(fpgFlimViewEnd).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewEnd).tz("US/Mountain").format('h:mm A')}
                                </td>
                                <td className="screening_type">
                                  {this.getScreeningName(item) }
                                </td>
                                <td>

                                  {
                                    item?.locationType === undefined || item?.locationType === "2" ? <span className="d_block"> Online </span> :
                                      item?.locations.length > 0 ? item?.locations.map((loc) => {
                                        return <span className="d_block"> {loc?.name} &nbsp;</span>
                                      }) : ''
                                  }

                                </td>
                                <td className="waitlist_slot">{(item.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item.maxWaitListSlots}</td>
                                <td className="waitlist_slot">{item.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                                  <span>+ More</span>
                                  <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                                </>}</td>
                                <td className="waitlist_slot">{renderInterestTracks(item.interestTrack)}</td>
                                <td className="waitlist_slot">{item.supressVoting ? 'Y' : 'N'}</td>
                              </tr>
                            )
                          })
                        }
                        </tbody>
                    </table>
                  </div>
                  <div className="data_list">
                    <ul>
                      <li className="d_flex">
                        <label>Genre</label>
                        <span>
                          {this.state.genre &&
                            this.state.genre.map((item) => <p>{item.name}</p>)}
                        </span>
                      </li>
                      <li className="d_flex">
                        <label>Interest Tracks</label>
                        <span>
                          {this.state.interestTrack &&
                            this.state.interestTrack.map((item) => (
                              <p>{item.name}</p>
                            ))}
                        </span>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <label>RunTime</label>
                        <span>{this.state.runTime}</span>
                      </li>
                      <li className="d_flex">
                        <label>Shorts Program Sponsor</label>
                        <span>{ShortProgramList && ShortProgramList?.isSponsor ? 'Yes' : 'No'}</span>
                      </li>
                      <li className="d_flex">
                        <label>Sponsor Logo
                        </label>
                        <span>
                          <img
                            src={
                              ShortProgramList && ShortProgramList?.sponsorLogo ?
                                this.apiserve.imageUrl + ShortProgramList?.sponsorLogo :
                                '/images/image-placeholder.png'
                            }
                            alt="image"
                          /></span>
                      </li>
                      <li className="d_flex">
                        <label>Explicit Content</label>
                        <span>{ShortProgramList && ShortProgramList?.isExplicitContent ? 'Yes' : 'No'}</span>
                      </li>
                      <li className="d_flex">
                        <label>Explicit Content Disclaimer</label>
                        <span className="editor_view p_0 ml_25" dangerouslySetInnerHTML={{ __html: ShortProgramList && ShortProgramList?.explicitContent }} />
                      </li>
                      <li className="d_flex">
                        <label>Short Description</label>
                        <span className="editor_view p_0 ml_25" dangerouslySetInnerHTML={{ __html: ShortProgramList && ShortProgramList?.shortDescription }} />
                      </li>
                      <li className="d_flex">
                        <label>Long Description</label>
                        <span className="editor_view p_0 ml_25" dangerouslySetInnerHTML={{ __html: ShortProgramList && ShortProgramList?.longDescription }} />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            this.state.selectshort ?
              <div className="program_popup" style={{ zIndex: "9999" }}>
                <div className="program_popup_header d_flex d_flex_justify_spacebt d_flex_align_center">
                  <span className="header_title">Select Shorts</span>
                  <div className="relative field_row mb_0">
                    <div className="field_input">

                    </div>
                  </div>
                </div>
                <div className="popup_content">
                  <div className="customCheckBox">
                    <input
                      type="checkbox"
                      id="short"
                      name="short"
                      value="short"
                    />
                    <label htmlFor="short">This Is Not a Burial, It's a Resurrection</label>
                  </div>
                  <div className="customCheckBox">
                    <input
                      type="checkbox"
                      id="short2"
                      name="short2"
                      value="short2"
                    />
                    <label htmlFor="short2">This Is Not a Burial, It's a Resurrection</label>
                  </div>

                  <div className="field_row text_center pt_25">
                    <button>CANCEL</button>
                    <button className="active">SUBMIT</button>
                  </div>
                </div>
              </div>
              :
              ""
          }

          {this.state.loaderFlag ? (
            <Loader />
          ) : (
            ""
          )}

          {this.state.errorPopup ?
            <ErrorPopUp
              errorMsg={this.state.errorMsg}
              errorMsgPopup={this.errorMsgPopup}
            />
            : ''
          }

          {this.state.deleteFilm ?
            <PopUpCustomAll
              HeaderName='Delete?'
              insideDetails='You are about to delete an item and this action is permanent'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.deleteFilmPopupYes}
            />
            : ''}

          {this.state.publishFilm ?
            <PopUpCustomAll
              HeaderName='Publish Changes'
              insideDetails='Saving the current changes will publish it to the production site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.publishFilmPopupYes}
            />
            : ''}
          {this.state.hideFromLiveFilm ?
              <PopUpCustomAll
                HeaderName='Show On Live?'
                insideDetails='Saving the current changes will show it to the site'
                insideData='Do you want to proceed?'
                popupState={this.closeAdminUser}
                yesPopUp={this.showFromLiveFilmPopupYes}
              />
              : ''
          }
          {this.state.showFromLiveFilm ?
              <PopUpCustomAll
                HeaderName='Hide From Live'
                insideDetails='Saving the current changes will hide it from the site'
                insideData='Do you want to proceed?'
                popupState={this.closeAdminUser}
                yesPopUp={this.hideFromLiveFilmPopupYes}
              />
              : ''
          }
          {this.state.disableFilm ?
            <PopUpCustomAll
              HeaderName='Disable?'
              insideDetails='You are about to disable an item, which will temporarily make it unavailable on the production site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.disableFilmPopupYes}
            />
            : ''}
          {/* Loader */}
          {this.state.loaderFlag ? (
            <Loader />
          ) : (
            ""
          )}
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgramView);
